import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RetailItem } from "src/app/particulier/core/model/retail-item";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { Produit } from "src/app/parametrage/core/model/produit";
import { RetailItemService } from "src/app/particulier/core/service/retail-item.service";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { Assurance } from "src/app/parametrage/core/model/assurance";
import { AssuranceService } from "src/app/parametrage/core/service/assurance.service";
import { TauxFraisOutput } from "src/app/particulier/core/model/rule/taux-frais-output";
import { TauxFraisInput } from "src/app/particulier/core/model/rule/taux-frais-input";
import { RuleParticulierService } from "src/app/particulier/core/service/rule-particulier.service";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";

@Component({
  selector: "app-edit-credit-modal",
  templateUrl: "./edit-credit-modal.component.html",
  styleUrls: ["./edit-credit-modal.component.scss"],
})
export class EditCreditModalComponent implements OnInit {
  @Input() retailItemId;
  @Input() workflowCode;

  individual: Individual;
  retailItem: RetailItem;

  tauxFraisInput: TauxFraisInput = new TauxFraisInput();
  tauxFraisOutput: TauxFraisOutput;

  assurances: Assurance[];

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  typeCredits: TypeCredit[];
  produits: Produit[];
  typeCredit: TypeCredit;

  periodicite: String = "MENSUEL";

  @ViewChild("disabledHtml", { static: true }) disabledHtml: ElementRef;

  MyPermissions: string[];

  blockUpdateProduit: Boolean = true;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _retailItemService: RetailItemService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private _assuranceService: AssuranceService,
    private _ruleParticulierService: RuleParticulierService,
    private _individualService: IndividualService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _keycloakService: KeycloakService
  ) {
    this.createForm();
    this.MyPermissions = _keycloakService.getAccessPermissions();
  }

  ngOnInit() {
    this.getRetailItemById(this.retailItemId);
    this.getListTypeCredit();
  }

  createForm() {
    this.form2 = this.fb.group({
      taux: [null, Validators.compose([Validators.required])],
      periodicite: ["MENSUEL", Validators.compose([Validators.required])],
      echeance: [null, Validators.compose([Validators.required])],
      montant: [null, Validators.compose([Validators.required])],
      montantAccorde: [null, Validators.compose([Validators.required])],
      tauxAccorde: [null, Validators.compose([Validators.required])],
      echeanceAccorde: [null, Validators.compose([Validators.required])],
      montantVirementPermanent: [
        null,
        Validators.compose([Validators.required]),
      ],
      frais: [null, Validators.compose([Validators.required])],
      typeCredit: [null, Validators.compose([Validators.required])],
      produit: [null, Validators.compose([Validators.required])],
      echeanceMensuelleEnCours: [
        null,
        Validators.compose([Validators.required]),
      ],
      assurance: [null, Validators.compose([Validators.nullValidator])],
      objetDemande: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(21843),
        ],
      ],
    });
  }

  getIndividualByRequestId(requestId) {
    this._individualService.getIndividualByRequestId(requestId).subscribe(
      (data) => {
        this.individual = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRetailItemById(retailItemId) {
    this._retailItemService.getRetailItemById(retailItemId).subscribe(
      (data) => {
        this.retailItem = data;

        this.produits = [];
        this.produits.push(this.retailItem.produit);

        if (this.retailItem.montantAccorde == null) {
          this.retailItem.montantAccorde = this.retailItem.montant;
        }

        if (this.retailItem.tauxAccorde == null) {
          this.retailItem.tauxAccorde = this.retailItem.taux;
        }

        if (this.retailItem.echeanceAccorde == null) {
          this.retailItem.echeanceAccorde = this.retailItem.echeance;
        }

        let permission = this.MyPermissions.find(
          (x) => x == "particulier_modifier_typecredit"
        );
        if (permission != null) {
          this.blockUpdateProduit = false;
        }

        this.getIndividualByRequestId(this.retailItem.request.id);

        this.form2.controls["typeCredit"].setValue(
          this.retailItem.produit.typeCredit.id
        );
        this.getTypeCreditById();

        this.form2.controls["montant"].setValue(this.retailItem.montant);
        this.getListAssuranceByAmount();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListTypeCredit() {
    this._typeCreditService
      .getListTypeCreditByWorkflow(this.workflowCode)
      .subscribe(
        (data) => {
          this.typeCredits = data.sort((a, b) => (a.label > b.label ? 1 : -1));
        },
        (error) => {
          console.log(error);
        }
      );
  }

  changeProduits() {
    let typeCreditId = this.form2.controls["typeCredit"].value;
    this.getListproduitByTypeCredit(typeCreditId);
  }

  getListproduitByTypeCredit(typeCreditId) {
    this._produitService.getListproduitByTypeCredit(typeCreditId).subscribe(
      (data) => {
        this.produits = data;
        this.getTypeCreditById();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  synchEcheanceAccorde() {
    this.form2.controls["echeanceAccorde"].setValue(
      this.form2.controls["echeance"].value
    );
  }

  synchTauxAccorde() {
    this.form2.controls["tauxAccorde"].setValue(
      this.form2.controls["taux"].value
    );
  }

  getListAssuranceByAmount() {
    this.assurances = [];
    this._assuranceService
      .getAssurancesByAmount(
        this.retailItem.produit.typeCredit.code,
        Number(this.form2.value.montant)
      )
      .subscribe(
        (data) => {
          this.assurances = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  update(): void {
    this.spinner.show();
    this._retailItemService
      .putRetailItem(this.retailItem)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  getTypeCreditById() {
    this._typeCreditService
      .getTypeCreditById(this.form2.value.typeCredit)
      .subscribe(
        (data) => {
          this.typeCredit = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getTauxFrais() {
    this.tauxFraisInput.codeTypeCredit = this.typeCredit.code;
    this.tauxFraisInput.employeur = this.individual.employeur.label;
    this.tauxFraisInput.montantDemande = this.form2.value.montant;
    this.tauxFraisInput.echeanceMois = this.calculEcheanceAvecPeriodicite();

    this._ruleParticulierService.ruleTauxFrais(this.tauxFraisInput).subscribe(
      (data) => {
        this.tauxFraisOutput = data;
        this.form2.controls["echeanceMensuelleEnCours"].setValue(
          this.tauxFraisOutput.echeanceMensuelleEnCours
        );
        this.form2.controls["taux"].setValue(this.tauxFraisOutput.taux);
        this.form2.controls["frais"].setValue(this.tauxFraisOutput.frais);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  calculEcheanceAvecPeriodicite(): number {
    let echeance = 0;

    if (this.form2.value.periodicite == "MENSUEL") {
      echeance = Number(this.form2.value.echeance) * 1;
    } else if (this.form2.value.periodicite == "TRIMESTRIEL") {
      echeance = Number(this.form2.value.echeance) * 3;
    } else if (this.form2.value.periodicite == "SEMESTRIEL") {
      echeance = Number(this.form2.value.echeance) * 4;
    } else if (this.form2.value.periodicite == "ANNUEL") {
      echeance = Number(this.form2.value.echeance) * 12;
    }

    return echeance;
  }
}
